import * as z from "zod/v4";

export const getIntelligentInventoryThread = {
  name: "getIntelligentInventoryThread" as const,
  input: z.object({ threadId: z.string() }),
  output: z.object({
    threadId: z.string(),
    pendingConfirmations: z.array(
      z.object({
        toolCallId: z.string(),
        toolName: z.string(),
        confirmationData: z.unknown(),
        confirmationPrompt: z.string(),
      }),
    ),
  }),
};
